import { t as e } from "./Area-MLM4Xe0E.js";
//#region src/reader/MapReader.ts
var t = {
	rgb: [
		114,
		1,
		0
	],
	rgbValue: "rgb(114, 1, 0)",
	symbolColor: [
		225,
		225,
		225
	],
	symbolColorValue: "rgb(225,225,225)"
};
function n(e) {
	let t = e[0] / 255, n = e[1] / 255, r = e[2] / 255;
	return (Math.max(t, n, r) + Math.min(t, n, r)) / 2;
}
var r = class {
	constructor(t, r) {
		this.rooms = {}, this.areas = {}, this.colors = {}, t.forEach((t) => {
			let n = {
				...t,
				rooms: t.rooms.map((e) => ({
					...e,
					y: -e.y
				}))
			};
			n.rooms.forEach((e) => {
				this.rooms[e.id] = e;
			});
			let r = parseInt(t.areaId);
			this.areas[r] = new e(n);
		}), this.colors = r.reduce((e, t) => ({
			...e,
			[t.envId]: {
				rgb: t.colors,
				rgbValue: `rgb(${t.colors.join(",")})`,
				symbolColor: n(t.colors) > .41 ? [
					25,
					25,
					25
				] : [
					225,
					255,
					255
				],
				symbolColorValue: n(t.colors) > .41 ? "rgb(25,25,25)" : "rgb(225,255,255)"
			}
		}), {});
	}
	getArea(e) {
		return this.areas[e];
	}
	getAreas() {
		return Object.values(this.areas);
	}
	getRooms() {
		return Object.values(this.rooms);
	}
	getRoom(e) {
		return this.rooms[e];
	}
	getColorValue(e) {
		return this.colors[e]?.rgbValue ?? t.rgbValue;
	}
	getSymbolColor(e, n) {
		let r = this.colors[e]?.symbolColor ?? t.symbolColor, i = Math.min(Math.max(n ?? 1, 0), 1), a = r.join(",");
		return i == 1 ? `rgba(${a})` : `rgba(${a}, ${i})`;
	}
};
//#endregion
export { r as t };

//# sourceMappingURL=MapReader-BeVNpm6y.js.map